import { render, staticRenderFns } from "./PostsWidget.vue?vue&type=template&id=59c178e5&scoped=true&"
import script from "./PostsWidget.vue?vue&type=script&lang=js&"
export * from "./PostsWidget.vue?vue&type=script&lang=js&"
import style0 from "./PostsWidget.vue?vue&type=style&index=0&id=59c178e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c178e5",
  null
  
)

export default component.exports